var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVanP(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "van",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_21",
    "data-name": "Rect\\xE1ngulo 21",
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "recreational-vehicle",
    d: "M19.2,9.727h1.863V7.863L19.2,6H3.363A1.863,1.863,0,0,0,1.5,7.863v8.385a1.863,1.863,0,0,0,1.863,1.863H4.3a2.8,2.8,0,0,0,5.59,0h4.659a2.8,2.8,0,1,0,5.59,0H22V13.454M7.09,19.51a1.4,1.4,0,1,1,1.4-1.4,1.4,1.4,0,0,1-1.4,1.4m1.863-6.056H3.363v-2.8h5.59m4.659,5.59h-2.8v-5.59h2.8m3.727,8.851a1.4,1.4,0,1,1,1.4-1.4,1.435,1.435,0,0,1-1.4,1.4m-.932-6.056V11.124h2.329L20.6,13.454Z",
    transform: "translate(0.5 -1)",
    fill: "#ff5821"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVanP);
export default __webpack_public_path__ + "static/media/van_p.1a2723e06f2eaa43588c67bd72ff3fce.svg";
export { ForwardRef as ReactComponent };